import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class PublicInfoAPICall extends APICallV4 {
    _method = 'public/info';
    _type: Method = 'get';
}
